import { ReactElement } from "react"
import { pushClickSessionCta } from "../../../../utils/gtm"
import { PartnerProps } from "./partner-props"
import * as S from './partner-style'

export function Partner ({ id, name, values, urlBuilder, params }: PartnerProps): ReactElement {
  return <S.Container id={id}>
    <S.Wrapper>
      <h5>{values.title}</h5>
      <S.Content>
        <S.ScrollContent>
          {values.items.map(item => <a href={urlBuilder.build(item.link, params)} onClick={() => pushClickSessionCta(name)}>
            <img src={item.image} alt={item.name} />
          </a>)}
        </S.ScrollContent>
      </S.Content>
    </S.Wrapper>
  </S.Container>
}
